import React, { useEffect, useState } from "react";
import { Row, Col, Table, Skeleton, Typography, Divider, DatePicker } from "antd";
import dayjs from 'dayjs';
import ERMDOfficerReportCard from "./officerReport";
import IndexReportCard from "./indexReport";
import axios from "../../../helpers/Axios";
import { Main } from '../../styled';
import OverviewCard from '../../../components/cards/OverviewCard';

const { Title } = Typography;
const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';

const filingHeaders = {
    headers: {
        'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY_FILING,
    },
};

const ERMDDashboard = () => {
    const [counts, setCounts] = useState([]);
    const [loadingCounts, setLoadingCounts] = useState(true);

    const userId = localStorage.getItem("user_id");
    const currentMonthYear = dayjs().format("MMMM YYYY");
    const currentDateVerbose = dayjs().format("DD MMMM, YYYY");

    const statuses = [
        { id: 2, label: "For Review" },
        { id: 3, label: "Accepted" },
        { id: 4, label: "Reverted" },
        { id: 14, label: "Cancelled" },
    ];

    const cardStyles = {
        "For Review": { icon: "forReview.svg", type: "primary" },
        "Accepted": { icon: "accepted.svg", type: "success" },
        "Reverted": { icon: "reverted.svg", type: "warning" },
        "Cancelled": { icon: "cancelled.svg", type: "danger" },
    };

    // useEffect(() => {
    //     const fetchCounts = async () => {
    //         setLoadingCounts(true);

    //         try {
    //             // Your version 2 centralized endpoint
    //             const { data } = await axios.get('https://api.fortisph.space/gateway/filing/forms/count/', {
    //                 ...filingHeaders,
    //                 params: {
    //                     user_id: userId,
    //                 },
    //             });

    //             // Map the unified API response data straight into the dashboard state structure
    //             setCounts([
    //                 {
    //                     status: 'For Review',
    //                     day: data?.for_review?.today ?? 0,
    //                     month: data?.for_review?.monthly ?? 0,
    //                 },
    //                 {
    //                     status: 'Accepted',
    //                     day: data?.accepted?.today ?? 0,
    //                     month: data?.accepted?.monthly ?? 0,
    //                 },
    //                 {
    //                     status: 'Reverted',
    //                     day: data?.reverted?.today ?? 0,
    //                     month: data?.reverted?.monthly ?? 0,
    //                 },
    //                 {
    //                     status: 'Cancelled',
    //                     day: data?.cancelled?.today ?? 0,
    //                     month: data?.cancelled?.monthly ?? 0,
    //                 },
    //             ]);
    //         } catch (err) {
    //             console.error('Failed to fetch dashboard counts:', err);
    //             setCounts([]);
    //         } finally {
    //             setLoadingCounts(false);
    //         }
    //     };

    //     if (userId) {
    //         fetchCounts();
    //     }
    // }, [userId]);

    useEffect(() => {
        if (!userId) return;

        // Track mounting to prevent memory leak state updates if component unmounts mid-transit
        let isMounted = true;
        setLoadingCounts(true);

        const periods = ["today", "monthly"];
        const requests = [];
        const keys = [];

        statuses.forEach((status) => {
            periods.forEach((period) => {
                keys.push({ status: status.label, period });

                // Fixed: Explicitly routed through your external API Gateway mapping domain
                const url = `https://api.fortisph.space/gateway/filing/forms/count/`;

                requests.push(
                    axios.get(url, {
                        ...filingHeaders,
                        params: {
                            user_id: userId,
                            status: status.id,
                            frequency: period,
                        }
                    })
                );
            });
        });

        Promise.all(requests)
            .then((responses) => {
                if (!isMounted) return;

                const result = statuses.map((status) => {
                    // Find the index positions inside the keys tracking array
                    const dayResponseIdx = keys.findIndex(k => k.status === status.label && k.period === "today");
                    const monthResponseIdx = keys.findIndex(k => k.status === status.label && k.period === "monthly");

                    // Safely query the exact counted integer metric returned by the backend views
                    const dayCount = dayResponseIdx !== -1 ? (responses[dayResponseIdx]?.data?.count ?? 0) : 0;
                    const monthCount = monthResponseIdx !== -1 ? (responses[monthResponseIdx]?.data?.count ?? 0) : 0;

                    return {
                        status: status.label,
                        day: dayCount,
                        month: monthCount
                    };
                });

                setCounts(result);
            })
            .catch((err) => {
                console.error("Failed parsing legacy matrix counts:", err);
                if (isMounted) setCounts([]);
            })
            .finally(() => {
                if (isMounted) setLoadingCounts(false);
            });

        return () => {
            isMounted = false;
        };
    }, [userId]);

    const cards = counts.map(item => ({
        label: item.status,
        totalToday: item.day,
        totalMonth: item.month,
        icon: cardStyles[item.status].icon,
        type: cardStyles[item.status].type
    }));


    // const columns = [
    //     {
    //         title: 'Submission Status',
    //         dataIndex: 'status',
    //         key: 'status',
    //         align: 'center',
    //     },
    //     {
    //         title: 'Counts',
    //         dataIndex: 'counts',
    //         key: 'counts',
    //         align: 'center',
    //         children: [
    //             {
    //                 title: `As of ${currentDateVerbose}`,
    //                 dataIndex: 'day',
    //                 key: 'day',
    //                 align: 'center',
    //             },
    //             {
    //                 title: `As of ${currentMonthYear}`,
    //                 dataIndex: 'month',
    //                 key: 'month',
    //                 align: 'center',
    //             },
    //         ]
    //     },

    // ];

    return (
        <Main>
            <Row gutter={16} style={{ paddingTop: '10px' }}>
                <Col className="gutter-row" sm={24} md={24} lg={24}>
                    <Title level={4}>ERMD Dashboard</Title>
                </Col>
            </Row>
            <Divider style={{ backgroundColor: '#d7d7d7', margin: '8px 0 32px', }} />
            {loadingCounts ? <Skeleton active /> :
                <Row gutter={16}>
                    {cards.map(card => (
                        <Col xs={12} md={6} xl={6} key={card.label}>
                            <OverviewCard data={card} />
                        </Col>
                    ))}
                    <Divider style={{ backgroundColor: '#d7d7d7', margin: '8px 0 32px', }} />
                    <Col xs={24} lg={12}>
                        <ERMDOfficerReportCard />
                    </Col>
                    <Col xs={24} lg={12}>
                        <IndexReportCard />
                    </Col>
                </Row>
            }

        </Main>
    );
};

export default ERMDDashboard;
